import { Box } from '@mui/material';

import { SlideDialog } from '@modules/_shared/components/SlideDialog';
import { useLocale } from '@shared/hooks/locale';

import { ReviewInvitationContent } from './ReviewInvitationContent';

type ReviewInvitationModalProps = {
  open: boolean;
  onClose: () => void;
  initialAgentId?: string | null;
};

export const ReviewInvitationModal = ({
  open,
  onClose,
  initialAgentId,
}: ReviewInvitationModalProps) => {
  const { t } = useLocale();

  return (
    <SlideDialog
      open={open}
      onClose={onClose}
      title={t('Request a review')}
      maxWidth="sm"
      footerActions={<Box />}
    >
      <ReviewInvitationContent initialAgentId={initialAgentId} />
    </SlideDialog>
  );
};
